<template lang="pug">
  span#reports
    .md-layout
      .md-layout-item.ml-auto
        md-button.md-warning(
          style='float: right;'
          @click='createDialog')
          v-icon(style='color: black !important; padding-right: 4px;') mdi-plus
          span(style='color: black')
            | {{$t('managementAccess.create')}}
    div
      DataProvider(:endpoint='mountUrlAndParams("roles").url' :filter='filter' ref='dataProvider')
        div(slot-scope='{ data: response, error, loading }')
          DataTable(
            excludeHeader
            customIcon='manage-account'
            :data='response && response.hits'
            ref='dataTable'
            :title="$t('managementAccess.usersProfile')"
            :customTotal='(response && response.total) || 0'
            @pagination='handlePagination'
            :currentSort.sync='filter.orderBy',
            :currentSortOrder.sync='filter.order',
            :selectable='false'
            :loading='loading'
            :endpoint='mountUrlAndParams("role").url'
            :filter='filter'
            :labels='labels'
            :excludeHeader='false'
            :button-headers='false'
            :customHeader="true"
            :formatLabelFunction='formatLabels'
            :fileName="$t('campaign.fileName')")
            template(slot='footer' slot-scope='{ pagination }')
              v-row(style='justify-content: flex-end;')
                v-col(cols='auto')
                  md-field
                    label(for='pages') {{ $t('assistantsList.perPage') }}
                    md-select(v-model='pagination.perPage' name='pages' )
                      md-option(
                        v-for='item in pagination.perPageOptions',
                        :key='item',
                        :label='item',
                        :value='item')
                        | {{ item }}
            template(slot='cells' slot-scope='{ item }')
              md-table-cell(:md-label='labels[0]') {{ formatLabels(item, 0) }}
              md-table-cell(:md-label='labels[1]') {{ formatLabels(item, 1) }}
              md-table-cell(:md-label='labels[2]') {{ formatLabels(item, 2) }}
              md-table-cell(:md-label='labels[3]') {{ formatLabels(item, 3) }}
              md-table-cell(:md-label='labels[4]') {{ formatLabels(item, 4) }}
              md-table-cell(:md-label='$t("managementAccess.actions")')
                v-row(no-gutters style='justify-content: flex-start;')
                  v-col(cols='auto' style='padding: 4px; margin: 8px 0;')
                    v-btn(
                      class="mx-2"
                      x-small
                      fab
                      dark
                      color="#20A6E5"
                      @click='openViewOnlyDialog(item)'
                    )
                      v-icon(dark)
                        | visibility
                    md-tooltip(md-direction="bottom")
                      | {{$t('managementAccess.viewRole')}}
                  v-col(cols='auto' style='padding: 4px; margin: 8px 0;')
                    v-btn(
                      class="mx-2"
                      x-small
                      fab
                      dark
                      color="#4caf50"
                      @click='editDialog(item)'
                    )
                      v-icon(dark)
                        | create
                    md-tooltip(md-direction="bottom")
                      | {{$t('managementAccess.editRole')}}
                  v-col(cols='auto' style='padding: 4px; margin: 8px 0;')
                    v-btn(
                      @click='openDeleteModal(item)'
                      style='margin-right: 3px'
                      class="mx-2"
                      x-small
                      fab
                      dark
                      color="#f44336"
                    )
                      v-icon(dark)
                        | delete
                    md-tooltip(md-direction="bottom")
                      | {{$t('managementAccess.deleteRole')}}
    ManageAccessUserProfileModal(
      :viewOnly="viewOnlyDialog"
      :itemData='itemData'
      :show-modal='showProfileForm'
      :functionList='functionList'
      @closeModal='closeModal'
      @successOnSave='forceRerender'
      :requestUrl="requestUrl"
      :method="method"
    )

    SimpleModal(
      :showModal="deleteModal"
      max-width='700px'
      scrollable
      headerColor="none"
      lButtonColor='#F44336'
      rButtonColor='#4CAF50'
      :lButtonTitle="$t('commonWords.no')"
      @clickLButton='closeModal()'
      showRButton
      showLButton
      :rButtonTitle="$t('commonWords.yes')"
      @clickRButton='deleteAndValidate()'
    )
      template(slot='content')
        v-col
          v-row(style='justify-content: center;')
            AlertCircle
          v-row
            h2.text-center {{ $t('managementAccess.confirmDeleteRole') }}

</template>

<script>
import moment from 'moment'
import Swal from 'sweetalert2'

import { selectedLocale } from '@/plugins/i18n'
import DataTable from '@/components/DataTable'
import DataProvider from '@/components/DataProvider'
import ManageAccessUserProfileModal from '@/components/ManageAccessUserProfileModal'
import GlobalDialog from '@/components/Reuse/GlobalDialog'
import SimpleModal from '@/components/Reuse/SimpleModal'

import AlertCircle from '@/assets/img/alert-circle.svg'
import ErrorCircle from '@/assets/img/error-circle.svg'

export default {
  components: {
    SimpleModal,
    GlobalDialog,
    DataTable,
    DataProvider,
    ManageAccessUserProfileModal,
    AlertCircle,
    ErrorCircle
  },

  data () {
    return {
      componentKey: 0,
      deleteItemCarry: '',
      rolesList: [],
      itemData: {},
      deleteModal: false,
      functionList: [],
      labels: [this.$t('managementAccess.profileName'), this.$t('managementAccess.description'), this.$t('managementAccess.numberOfUsers'), this.$t('managementAccess.createdAt'), this.$t('managementAccess.createdBy'), this.$t('managementAccess.actions')],
      showProfileForm: false,
      deleteTemplateModel: false,
      viewOnlyDialog: false,
      requestUrl: '',
      method: 'post',
      filter: {
        order: 'desc',
        from: 0,
        size: 5
      }
    }
  },
  async mounted () {
    if (this.functionList.length > 0) return
    await this.getAllFunctions().then((response) => {
      this.functionList = response?.data?.hits?.map(value => value._source.name)
    })
  },
  methods: {
    async getAllFunctions () {
      if (this.features?.length > 0) return
      return this.$axios.get(
        this.mountUrlAndParams('functions').url,
        {
          params: {
            size: 1000
          }
        }
      )
    },
    forceRerender () {
      if (this.$refs.dataProvider) {
        this.$refs.dataProvider.load()
      }
    },
    mountUrlAndParams (endpoint, id) {
      if (id) {
        return {
          url: `${process.env.VUE_APP_AUTH_BASE_URL}/${endpoint}/${id}`
        }
      }
      return {
        url: `${process.env.VUE_APP_AUTH_BASE_URL}/${endpoint}`
      }
    },

    async openDeleteModal (item) {
      this.deleteItemCarry = item
      this.deleteModal = true
    },

    async deleteAndValidate () {
      const deleteItem = this?.deleteItemCarry?._source
      if (deleteItem?.associatedUsers > 0) {
        Swal.fire({
          icon: 'error',
          title: this.$t('managementAccess.roleDeleteErrorAmount'),
          showConfirmButton: false,
          timer: 1500
        })
        this.deleteModal = false
        return
      }
      await this.$axios.delete(this.mountUrlAndParams('role', this.deleteItemCarry._id).url).then(() => {
        Swal.fire({
          icon: 'success',
          title: this.$t('managementAccess.roleDeleted'),
          showConfirmButton: false,
          timer: 1500
        }).then(() => {
          this.deleteModal = false
          this.forceRerender()
        })
      })
    },

    closeModal () {
      this.showProfileForm = false
      this.deleteModal = false
      this.deleteItemCarry = ''
      this.requestUrl = ''
      this.itemData = {
        name: '',
        description: '',
        functions: []
      }
    },
    createDialog () {
      this.showProfileForm = true
      this.viewOnlyDialog = false
      this.requestUrl = this.mountUrlAndParams('roles').url
      this.method = 'post'
    },
    editDialog (item) {
      this.showProfileForm = true
      this.itemData = item._source
      this.viewOnlyDialog = false
      this.requestUrl = this.mountUrlAndParams('role', item?._id).url
      this.method = 'put'
    },
    openViewOnlyDialog (item) {
      this.showProfileForm = true
      this.itemData = item._source
      this.viewOnlyDialog = true
      this.requestUrl = this.mountUrlAndParams('role', item?._id).url
      this.method = 'put'
    },
    handlePagination (pagination, oldPagination) {
      const newFilter = {}
      const { currentPage, perPage } = pagination
      const nextPage = perPage * (currentPage - 1)
      if (currentPage && this.filter.from !== nextPage) {
        newFilter.from = nextPage
      }
      if (perPage && this.filter.perPage !== perPage) {
        newFilter.perPage = perPage
      }
      Object.assign(this.filter, newFilter)
    },
    formatLabels (item, index) {
      switch (index) {
        case 0:
          return item?._source?.name
        case 1:
          return item?._source?.description
        case 2:
          return item?._source?.associatedUsers
        case 3:
          return moment(item?._source?.created?.at).locale(selectedLocale).format('L LT')
        case 4:
          return item?._source?.created?.by
      }
    }
  }
}
</script>
